import React,  { Component } from 'react';
import { Modal, DatePicker, Button, Spin, message } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import SearchRetrieveBtn from '../../../common/SearchRetrieveBtn.js';
import TableC from '../../../basicElement/TableC';
import Text from '../../../basicElement/Text';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class All extends Component {
    state = {
        data: {},
        auth: false,
        visible: false,
        loading: false,
    }

    loadData = () => {
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.delContractRemittanceApplication, {
        //     investigationJdeContractId,
        //     contractRemittanceApplicationId,
        // }).then(res => {
        //     const { data } = res;
        //     this.setState({
        //         auth: !!data,
        //         data: data || {},
        //         loading: false,
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ auth: false, data: {} });
    }
    
    show = () => {
        this.setState({
            data: {},
            auth: false,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirmDeauth = () => {
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.delContractRemittanceApplication, {
        //     investigationJdeContractId,
        //     contractRemittanceApplicationId,
        // }).then(res => {
        //     const { data } = res;
        //     this.setState({
        //         auth: !!data,
        //         data: data || {},
        //         loading: false,
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ auth: false, data: {} });
    }

    confirm = () => {
        const { data } = this.state;
        const { userId, begin, end } = data;
        if (!userId) {
            message.warning('请选择授权审批人');
            return;
        } else if (!begin) {
            message.warning('请选择授权开始时间');
            return;
        } else if (!end) {
            message.warning('请选择授权结束时间');
            return;
        }
        this.hide();
    }

    handleDateChange = (date, dateString, key) => {
        const { data } = this.state;
        data[key] = dateString;
        this.setState({ data });
    }

    handleChange = ({ text, value }) => {
        const { data } = this.state;
        data.userId = value;
        data.userName = text;
        this.setState({ data });
    }

    deauth = () => {
        const { auth } = this.state;
        if (auth) {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>确认解除授权？</div>,
                content: '解除授权后，此审批人不再代理BDO的审批工作',
                onOk: () => {
                    this.confirmDeauth();
                },
            });
        } else {
            this.setState({ data: {} });
        }
    }

    render() {
        const { loading, visible, data, } = this.state;
        const { userId, userName, begin, end } = data;
        return (
            <Modal
                title="授权审批人(所有报价单授权)"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{padding:0}}>
                        <ul className="modal-list">
                            <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left" style={{width: '25%'}}><Text asterisk={true} colon={true}>授权审批人</Text></div>
                                <div className="item-right" style={{width: '75%'}}>
                                    <div>
                                        <SearchRetrieve
                                            keyword='keyword'
                                            style={{ width: 182 }}
                                            placeholder="输入姓名/工号检索"
                                            value={userName}
                                            params={{ limit: 20 }}
                                            url={API_URL.investigation.queryUserByKey}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={option => this.handleChange(option, 'user')}
                                        />
                                        <Button type="primary" style={{marginLeft: 8}} disabled={!(userId || begin || end)} onClick={this.deauth}>解除授权</Button>
                                        <p style={{ color: '#999' }}>授权后，在授权时间内，可由代理审批人暂代您的审批工作</p>
                                    </div>
                                </div>
                            </li>
                            <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left" style={{width: '25%'}}><Text asterisk={true} colon={true}>授权时间</Text></div>
                                <div className="item-right" style={{width: '75%'}}>
                                    <DatePicker
                                        format={dateFormat}
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 120 }}
                                        value={begin ? moment(begin) : null}
                                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'begin')}
                                    />
                                    <span style={{ margin: '0 10px' }}>至</span>
                                    <DatePicker
                                        format={dateFormat}
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 120 }}
                                        value={end ? moment(end) : null}
                                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'end')}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

class Appoint extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
        saveParams: {},
        searchParams: {},
        pagination: {
            pageSize: 5,
            current: 1,
        },
    }

    loadData = () => {
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.delContractRemittanceApplication, {
        //     investigationJdeContractId,
        //     contractRemittanceApplicationId,
        // }).then(res => {
        //     const { data } = res;
        //     this.setState({
        //         auth: !!data,
        //         data: data || {},
        //         loading: false,
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({  data: [{ sponsorName: '泰拉克里昂（深圳）医疗设备有限公司' }] });
    }
    
    show = () => {
        this.setState({
            visible: true,
            saveParams: {},
            searchParams: {},
            pagination: {
                pageSize: 5,
                current: 1,
            },
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [{
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 80,
            render: (text, record) => {
                return <a onClick={() => this.delete(record)}>删除</a>
            }
        }];
        return columns;
    }

    handleChange = ({ text, value }) => {
        const { searchParams } = this.state;
        searchParams.sponsorId = value;
        searchParams.sponsorName = text;
        this.setState({ searchParams });
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{ marginLeft: 42 }}>确认要删除？</div>,
            content: '删除后，此申办方对应的报价单，将不再由其BD人员进行“BDO合理性审批”',
            onOk: () => {
                // this.setState({ loading: true });
                // const options = {
                //     method: 'POST',
                //     url: API_URL.contract.queryJdeMainApplyApprovalHistory,
                //     data: { jdeMainApplyId },
                //     dataType: 'json',
                //     doneResult: res => {
                //         this.setState({
                //             data: res.data,
                //             loading: false,
                //         })
                //     }
                // };
                // $.sendRequest(options);
            },
        });
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }
    
    handleAdd = ({ text, value }) => {
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.delContractRemittanceApplication, {
        //     investigationJdeContractId,
        //     contractRemittanceApplicationId,
        // }).then(res => {
        //     const { data } = res;
        //     this.setState({
        //         auth: !!data,
        //         data: data || {},
        //         loading: false,
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        const { data } = this.state;
        data.push({ sponsorName: text });
        this.setState({ data });
    }

    render() {
        const { data, visible, searchParams, pagination } = this.state;
        const { sponsorName } = searchParams;
        return (
            <Modal
                title="授权审批人(指定申办方授权)"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
            >
                {
                    <div className="modal-content" style={{padding:0}}>
                        <ul className="modal-list">
                            <li className="modal-item" style={{ lineHeight: '28px', borderBottom: '1px solid #d1d1d1' }}>
                                <div className="item-left" style={{width: '25%'}}><Text asterisk={true} colon={true}>申办方</Text></div>
                                <div className="item-right" style={{width: '75%'}}>
                                    <SearchRetrieveBtn
                                        keyword='customerCompanyName'
                                        style={{  width: 182 }}
                                        placeholder="输入名称检索"
                                        params={{ limit: 20, natureName: '申办方' }}
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={option => this.handleAdd(option, 'sponsor')}
                                    />
                                </div>
                                <p style={{ textAlign: 'center', color: '#999' }}>添加后，这些申办方的报价单，将由BD代理审批</p>
                            </li>
                            <div style={{ margin: '10px 0', overflow: 'hidden' }}>
                                <Button type="primary" style={{float: 'right', marginLeft: 8}}  onClick={this.search}>搜索</Button>
                                <SearchRetrieve
                                    keyword='customerCompanyName'
                                    style={{ float: 'right', width: 182 }}
                                    placeholder="输入名称检索"
                                    value={sponsorName}
                                    params={{ limit: 20, natureName: '申办方' }}
                                    url={API_URL.investigation.queryCustomerCompanyByName}
                                    config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                    onChange={option => this.handleChange(option, 'sponsor')}
                                />
                            </div>
                            <TableC
                                data={data}
                                columns={this.getColumns()}
                                className="authApprover"
                                pagination={pagination}
                                onChange={this.handleTableChange}
                            />
                        </ul>
                    </div>
                }
            </Modal>
        );
    }
}

export { All, Appoint };


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/AuthApprover.js